import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { CrmGameConceptStatus } from "../models/crmStatus";
import { getGameConceptsList } from "../redux/selectors";

export const MaxStartedApplications = 10;

export const useAmountOfStartedApplications = () => {
  const gameConceptsList = useSelector(getGameConceptsList);
  const [startedApplications, setStartedApplications] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!gameConceptsList) {
      return;
    }

    let amount = 0;
    for (const gameConceptKey of Object.keys(gameConceptsList)) {
      const concept = gameConceptsList[gameConceptKey];
      const conceptStatus = concept?.state?.status;
      if (
        conceptStatus !== CrmGameConceptStatus.Accepted &&
        conceptStatus !== CrmGameConceptStatus.Rejected
      ) {
        amount++;
      }
    }
    setStartedApplications(amount);
  }, [gameConceptsList]);

  return startedApplications;
};
